"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.newsBarConfig = void 0;
const NewsBar_contracts_1 = require("./NewsBar.contracts");
/**
 * @author Sebastian Dziechciarz, Stanisław Gregor
 */
exports.newsBarConfig = {
    [NewsBar_contracts_1.NewsBarColor.Black]: {
        bgClass: 'bg-gray-90',
        textClass: 'text-white'
    },
    [NewsBar_contracts_1.NewsBarColor.Blue]: {
        bgClass: 'bg-blue-80',
        textClass: 'text-white'
    },
    [NewsBar_contracts_1.NewsBarColor.Brand]: {
        bgClass: 'bg-brand-60',
        textClass: 'text-white'
    },
    [NewsBar_contracts_1.NewsBarColor.Gray]: {
        bgClass: 'bg-gray-10',
        textClass: 'text-black'
    },
    [NewsBar_contracts_1.NewsBarColor.Green]: {
        bgClass: 'bg-green-60',
        textClass: 'text-white'
    },
    [NewsBar_contracts_1.NewsBarColor.Custom]: {
        bgClass: 'bg-custom',
        textClass: 'text-white'
    }
};
//# sourceMappingURL=NewsBar.config.js.map